module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Sr_Ton1.3f87009d.jpg";